/* Smooth wheel scrolling (Lenis), desktop only. See snippets/smooth-scroll.liquid. */
(function() {
  if (typeof window.Lenis === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  /* Mouse/trackpad devices only; phones and tablets keep native scrolling. */
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var lenis = new window.Lenis({
    lerp: 0.1,
    smoothWheel: true,
    /* Panels with their own scroll keep it. */
    prevent: function(node) {
      return !!(node.closest && node.closest('[data-lenis-prevent], .quote-widget, .site-header__sheet, .cart-drawer, .search-overlay'));
    }
  });

  window.fkLenis = lenis;

  /* One clock: drive Lenis from GSAP's ticker so pinned/scrubbed
     ScrollTriggers stay in step with the smoothed scroll. */
  if (window.gsap && window.ScrollTrigger) {
    lenis.on('scroll', window.ScrollTrigger.update);
    window.gsap.ticker.add(function(time) { lenis.raf(time * 1000); });
    window.gsap.ticker.lagSmoothing(0);
  } else {
    var loop = function(time) {
      lenis.raf(time);
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  }

  /* Pause while something locks the page (quote modal adds
     html.quote-modal-open; menus set body overflow: hidden). */
  var root = document.documentElement;
  function syncLock() {
    var locked = root.classList.contains('quote-modal-open') || document.body.style.overflow === 'hidden';
    if (locked) lenis.stop();
    else lenis.start();
  }

  var observer = new MutationObserver(syncLock);
  observer.observe(root, { attributes: true, attributeFilter: ['class'] });
  observer.observe(document.body, { attributes: true, attributeFilter: ['style', 'class'] });
  syncLock();
})();
